import { configureStore } from "@reduxjs/toolkit";
import exampleReducer from "./exampleSlice";
import companyReducer from "./companySlice";
import authReducer from "./authSlice";
import tableReducer from "../feature/table/store/tableSlice";

const store = configureStore({
  reducer: {
    example: exampleReducer,
    company: companyReducer,
    auth: authReducer,
    table: tableReducer,
  },
});

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
